import { Loader } from '@/components/feedback/Loader/Loader';
import { PageLoaderContainer } from '@/components/feedback/PageLoader/PageLoader.styles';

export const PageLoader = () => {
  return (
    <PageLoaderContainer>
      <Loader hasLoadingText={false} size="6rem" />
    </PageLoaderContainer>
  );
};
